import { theme as baseTheme } from '@zing/white-label/styles/theme'
import { theme as tenantTheme } from '@zing/active-tenant/styles/theme'
import { ZingTheme } from './types'

export const mergedTheme: ZingTheme = {
  colors: { ...baseTheme.colors, ...(tenantTheme.colors ?? {}) },
  fonts: { ...baseTheme.fonts, ...(tenantTheme.fonts ?? {}) },
}
